import React, { useEffect, useState } from "react"
import { StaticQuery, graphql } from "gatsby"
import HomePage from "./homepage";


const Index = () => {
  return (
    <StaticQuery
      query={graphql`
      query {
        blogs: allMarkdownRemark(
            filter: {frontmatter: {type: {eq: "blog"}}}
            limit: 6
            sort: {order: DESC, fields: frontmatter___date}
        ) {
          nodes {
            id
            frontmatter {
              type
              author
              categories
              commentCount
              description
              slug
              title
              image
              date
            }
            fields {
              slug
            }
          }
        }
        caseStudies: allMarkdownRemark(
            filter: {frontmatter: {type: {eq: "case-study"}}}
            limit: 6
            sort: {order: DESC, fields: frontmatter___date}
        ) {
          nodes {
            id
            frontmatter {
              type
              author
              categories
              commentCount
              description
              slug
              title
              image
              date
            }
            fields {
              slug
            }
          }
        }
      }
    `}
      render={data => (
        <HomePage blogData={data.blogs.nodes} caseStudies={data.caseStudies.nodes} />
      )}
    />
  )
};

export default Index
